import * as zod from 'zod';

export const Robotiq2FControlKind = zod.enum(['move']);

export const Robotiq2FCommand = zod.object({
  kind: zod.literal('Robotiq2FCommand'),
  controlKind: Robotiq2FControlKind,
  targetGripWidth: zod.number().nonnegative(),
  targetSpeed: zod.number().nonnegative(),
  targetForce: zod.number().nonnegative(),
});

export type Robotiq2FCommand = zod.infer<typeof Robotiq2FCommand>;
